export default function MobileMenuHandler() {
    const mobileMenuBtn = document.querySelector("[data-toggle-menu]");
    const header = document.querySelector(".fu-header");
    const body = document.body;

    if (mobileMenuBtn !== null && header !== null) {
        const { bgColor, txtColor, drawerBgColor, drawerTxtColor } = header.dataset;

        mobileMenuBtn.addEventListener("click", function () {
            if (header.classList.contains("mobile-open")) {
                header.classList.remove(drawerBgColor, drawerTxtColor);
                header.classList.add(bgColor, txtColor);
                header.classList.remove("mobile-open");
                body.classList.remove("mobile-lock");
            } else {
                header.classList.remove(bgColor, txtColor);
                header.classList.add(drawerBgColor, drawerTxtColor);
                header.classList.add("mobile-open");
                body.classList.add("mobile-lock");
            }
            getScrollHeight();
        });
    }
}
